import React, { useContext } from "react";
import TransferContext from "../TranferContextProvider.js";
import { Col, Row } from "react-bootstrap";
import bankIcon from "../../../images/bank.png";
import promptpayIcon from "../../../images/promptpay.png";

const SelectPaymentChannel = () => {
  const {
    activeStep,
    setActiveStep,
    skipped,
    setSkipped,
    setPaymentChannel,
  } = useContext(TransferContext);

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleSelectBankAccount = () => {
    // Set payment channel to bank and go to UpdateBank component
    setPaymentChannel("bank");
    handleNext();
  };

  const handleSelectPromptPay = () => {
    // Set payment channel to promptpay and go to PromptPay component
    setPaymentChannel("promptpay");
    console.log("promptpay");
    handleNext();
  };

  return (
    <>
      <div className="border-content">
        <div className="d-flex px-3 pt-3 pb-3">
          เลือกช่องทางการรับเงิน
        </div>
        <hr
          className="mx-2"
          style={{ margin: "0px 0px 15px 0px", border: "solid 1px" }}
        />

        <Row className="mb-4">
          <Col xs={6} className="text-center">
            <div 
              className="payment-channel-option"
              onClick={handleSelectBankAccount}
              style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "20px",
                margin: "10px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                height: "100%"
              }}
            >
              <img 
                src={bankIcon} 
                alt="Bank Account" 
                style={{ 
                  width: "64px", 
                  height: "64px", 
                  marginBottom: "10px" 
                }} 
              />
              <div style={{ fontWeight: "bold" }}>บัญชีธนาคาร</div>
            </div>
          </Col>

          <Col xs={6} className="text-center">
            <div 
              className="payment-channel-option"
              onClick={handleSelectPromptPay}
              style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "20px",
                margin: "10px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                height: "100%"
              }}
            >
              <img 
                src={promptpayIcon} 
                alt="PromptPay" 
                style={{ 
                  width: "64px", 
                  height: "64px", 
                  marginBottom: "10px" 
                }} 
              />
              <div style={{ fontWeight: "bold" }}>บัญชีพร้อมเพย์</div>
            </div>
          </Col>
        </Row>
      </div>
      <button
        className="btn-checkout-back w-100 p-2 bold"
        onClick={handleBack}
      >
        กลับ
      </button>
    </>
  );
};

export default SelectPaymentChannel;
